import { msg } from '@lingui/core/macro'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

/**
 * Kept as a redirect — the lead detail merged into the unified project page,
 * which adapts to the row's phase (`wonAt`). Old funnel links keep working.
 */
export const Route = createFileRoute('/_authenticated/$workspaceSlug/funnel/$projectId')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, to: '/$workspaceSlug/projects/$projectId' })
  },
  head: () => ({ meta: [{ title: titleFor(msg`Lead`) }] }),
})
